import { WeightCalcTrendGroup, WeightYear } from ".";

export class WeightCalc {

    numberOfYears: number;
    projectedMonths: number;
    revenueTrend: WeightCalcTrendGroup;
    sdeTrend: WeightCalcTrendGroup;
    years: Array<WeightYear>;
    consistent: boolean;
    interim: boolean;

    static parse(json: any): WeightCalc {
        if (json) {
            const wc = new WeightCalc();

            wc.numberOfYears = json.numberOfYears;
            wc.projectedMonths = json.projectedMonths;

            if (json.revenueTrend)
                wc.revenueTrend = WeightCalcTrendGroup.parse(json.revenueTrend);

            if (json.sdeTrend)
                wc.sdeTrend = WeightCalcTrendGroup.parse(json.sdeTrend);

            wc.sdeTrend = json.sdeTrend;

            if (json.years)
                wc.years = WeightYear.parseArray(json.years);

            wc.consistent = json.consistent;
            wc.interim = json.interim;

            return wc;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<WeightCalc> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(WeightCalc.parse(j));

        return arr;
    }

}

